<div class="color-circle"
     *ngFor="let appColor of appColors"
     [ngStyle]="{'border-color': appColor.base}"
     [ngClass]="{'active': appColor.color === color, 'readonly': readonly}"
     (click)="onPickColor(appColor)">
  <div class="inner-circle" [ngStyle]="{'background-color': appColor.base}"></div>
</div>
